/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateModifierGroupsRequestInnerAllOfModifiersInner } from './UpdateModifierGroupsRequestInnerAllOfModifiersInner';
import {
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSON,
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSONTyped,
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSON,
    UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSONTyped,
} from './UpdateModifierGroupsRequestInnerAllOfModifiersInner';

/**
 * 
 * @export
 * @interface UpdateModifierGroupsRequestInner
 */
export interface UpdateModifierGroupsRequestInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateModifierGroupsRequestInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateModifierGroupsRequestInner
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModifierGroupsRequestInner
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateModifierGroupsRequestInner
     */
    max?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateModifierGroupsRequestInner
     */
    min?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModifierGroupsRequestInner
     */
    allowRepeat?: boolean;
    /**
     * 
     * @type {Array<UpdateModifierGroupsRequestInnerAllOfModifiersInner>}
     * @memberof UpdateModifierGroupsRequestInner
     */
    modifiers?: Array<UpdateModifierGroupsRequestInnerAllOfModifiersInner>;
}

/**
 * Check if a given object implements the UpdateModifierGroupsRequestInner interface.
 */
export function instanceOfUpdateModifierGroupsRequestInner(value: object): value is UpdateModifierGroupsRequestInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function UpdateModifierGroupsRequestInnerFromJSON(json: any): UpdateModifierGroupsRequestInner {
    return UpdateModifierGroupsRequestInnerFromJSONTyped(json, false);
}

export function UpdateModifierGroupsRequestInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateModifierGroupsRequestInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'max': json['max'] == null ? undefined : json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'allowRepeat': json['allowRepeat'] == null ? undefined : json['allowRepeat'],
        'modifiers': json['modifiers'] == null ? undefined : ((json['modifiers'] as Array<any>).map(UpdateModifierGroupsRequestInnerAllOfModifiersInnerFromJSON)),
    };
}

export function UpdateModifierGroupsRequestInnerToJSON(json: any): UpdateModifierGroupsRequestInner {
    return UpdateModifierGroupsRequestInnerToJSONTyped(json, false);
}

export function UpdateModifierGroupsRequestInnerToJSONTyped(value?: UpdateModifierGroupsRequestInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'enabled': value['enabled'],
        'max': value['max'],
        'min': value['min'],
        'allowRepeat': value['allowRepeat'],
        'modifiers': value['modifiers'] == null ? undefined : ((value['modifiers'] as Array<any>).map(UpdateModifierGroupsRequestInnerAllOfModifiersInnerToJSON)),
    };
}

